import React, { useEffect } from 'react';
import LandingNavbar from '@/components/landing/LandingNavbar';

type LandingShellProps = {
  children: React.ReactNode;
  showSectionLinks?: boolean;
};

export default function LandingShell({ children, showSectionLinks = true }: LandingShellProps) {
  useEffect(() => {
    document.documentElement.classList.add('allow-window-scroll');

    return () => {
      document.documentElement.classList.remove('allow-window-scroll');
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <LandingNavbar showSectionLinks={showSectionLinks} />
      <div className="pt-28 md:pt-20">{children}</div>
    </div>
  );
}
